import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useSport } from '@/hooks/useSport'
import { useApi } from '@/hooks/useApi'
import { fetchPosts } from '@/lib/api'
import { Skeleton } from '@/components/ui/Skeleton'
import { FilterButtonGroup } from '@/components/ui/FilterButtonGroup'

const CATEGORIES = [
  { label: 'All', value: 'all' },
  { label: 'Projections', value: 'tournament_projection' },
  { label: 'RPI Updates', value: 'rpi_update' },
]

export default function BracketologyIndex() {
  const { sport, sportLabel } = useSport()
  const [activeCategory, setActiveCategory] = useState('all')

  const { data: posts, loading } = useApi(
    () => fetchPosts(sport).then(d => d.posts || []),
    [sport],
  )

  const filtered = activeCategory === 'all'
    ? posts || []
    : (posts || []).filter((p) => p.category === activeCategory)

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-white">{sportLabel} Bracketology &amp; Posts</h1>

      <FilterButtonGroup options={CATEGORIES} value={activeCategory} onChange={setActiveCategory} className="w-fit" />

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} variant="card" className="h-36" />)}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((post) => (
            <Link
              key={post.id}
              to={`/${sport}/bracketology/${post.slug}`}
              className="card p-5 hover:border-accent/30 transition-colors group"
            >
              <span className="text-xs font-semibold text-accent/80 uppercase tracking-wider">
                {post.category?.replace('_', ' ')}
              </span>
              <h3 className="text-base font-semibold text-slate-100 mt-2 line-clamp-2 group-hover:text-white">
                {post.title}
              </h3>
              {post.summary && (
                <p className="text-sm text-slate-400 mt-2 line-clamp-2">{post.summary}</p>
              )}
              <div className="flex items-center gap-3 mt-3 text-xs text-slate-600">
                {post.published_at && (
                  <span>{new Date(post.published_at).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</span>
                )}
                {post.source && (
                  <>
                    <span>&middot;</span>
                    <span>{post.source}</span>
                  </>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}

      {!loading && !filtered.length && (
        <div className="card p-8 text-center">
          <p className="text-slate-500">No posts in this category yet.</p>
        </div>
      )}
    </div>
  )
}
